import { z } from 'zod';

export const healthResponseSchema = z.object({
  status: z.enum(['ok', 'degraded']),
  version: z.string(),
  uptimeSec: z.number(),
  checks: z.object({
    database: z.enum(['ok', 'fail']),
    redis: z.enum(['ok', 'fail']),
    storage: z.enum(['ok', 'fail']),
  }),
  /**
   * То, что сломано частично: функция не работает, но сервис жив.
   *
   * Отдельно от `checks`, потому что по `checks` считается код ответа. 503
   * из-за незаполненного SMTP означал бы, что деплой видит упавший стенд
   * и откатывается — из-за неработающего восстановления пароля.
   */
  warnings: z.array(z.string()).default([]),
});

export type HealthResponse = z.infer<typeof healthResponseSchema>;
